import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 90vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  > p {
    margin: 35px 0px;
    padding-left: 8px;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
  }

  span {
    margin: 35px 0px;
    padding-left: 16px;
    color: #f30303;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  margin: 0 -535px;
  /* top: 1050px; */
  /* bottom: -20px; */
  border: 0;
  width: 235px;
  height: 50px;
  background: var(--color-primary);
  border-radius: 5px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
`;
